export const CREATE_SITE_ERROR = 'CREATE_SITE_ERROR'
export const CREATE_SITE_SUCCESS = 'CREATE_SITE_SUCCESS'

export const DELETE_SITE = 'DELETE_SITE'
export const DELETE_SITE_ERROR = 'DELETE_SITE_ERROR'
export const DELETE_SITE_SUCCESS = 'DELETE_SITE_SUCCESS'

export const LOAD_SITES_SUCCESS = 'LOAD_SITES_SUCCESS'
export const UNLOAD_SITES_SUCCESS = 'UNLOAD_SITES_SUCCESS'

export const SET_CURRENT_SITE = 'SET_CURRENT_SITE'

export const START_PARSING = 'START_PARSING'

export const UPDATE_SITE_ERROR = 'UPDATE_SITE_ERROR'
export const UPDATE_SITE_SUCCESS = 'UPDATE_SITE_SUCCESS'

export const NEW_API_KEY_ADDED = 'NEW_API_KEY_ADDED'
export const API_KEY_DELETE = 'API_KEY_DELETE'



// WEBPACK FOOTER //
// ./src/modules/sites/action-types.js